import { render, staticRenderFns } from "./ChooseRequestType.vue?vue&type=template&id=7be24e8c&"
import script from "./ChooseRequestType.vue?vue&type=script&lang=js&"
export * from "./ChooseRequestType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports